import { render, staticRenderFns } from "./getSysOrg.vue?vue&type=template&id=3d2cd782&scoped=true&"
import script from "./getSysOrg.vue?vue&type=script&lang=js&"
export * from "./getSysOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2cd782",
  null
  
)

export default component.exports